import React from 'react';
import CategoryTemplate from 'templates/category';
import { useTranslation } from 'react-i18next';
import { useStaticQuery, graphql } from 'gatsby';

const CategoryPage = () => {
  const [t] = useTranslation();
  const image = useStaticQuery(graphql`
    query {
      strapiCategory(slug: { eq: "laxhjalp" }) {
        image {
          childImageSharp {
            fluid(maxHeight: 1024, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  `);
  return (
    <CategoryTemplate
      heading={t('page--homework.heading')}
      subheading={t('page--homework.subheading')}
      buttonLabel={t('page--homework.buttonLabel')}
      content={t('page--homework.content')}
      image={image.strapiCategory.image}
      ctaTitle={t('page--homework.ctaTitle')}
      seoTitle={t('page--homework.seoTitle')}
      seoDescription={t('page--homework.seoDescription')}
    />
  );
};
export default CategoryPage;
